import { BadgeCheck } from "lucide-react";
import { ABOUT } from "@/content/copy";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-sm font-bold uppercase tracking-widest text-terracotta">{ABOUT.overline}</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-navy">{ABOUT.title}</h2>
          {ABOUT.paragraphs.map((p) => (
            <p key={p.slice(0, 24)} className="mt-5 text-base text-navy/70 leading-relaxed">{p}</p>
          ))}
          <ul className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-3">
            {ABOUT.credentials.map((cred) => (
              <li key={cred} className="flex items-center gap-3 rounded-xl bg-background border border-border px-4 py-3">
                <BadgeCheck className="w-5 h-5 text-terracotta shrink-0" aria-hidden="true" />
                <span className="text-sm font-semibold text-navy">{cred}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
